export const CODEKICKBOT_SUPPORT_EMAIL = "support@codekickbot.com";
